// Copyright (c) 2016 Deere & Company

import './dealer-info.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const DealerInfo = ({dealerId, dealerName, industryIndicator, label, location}) =>
    <div className='customer-info'>
        <div className='label'>
            <FormattedMessage id={label}/>
        </div>
        <div className='data'>{dealerName}</div>
        <div className='location'>
            <div className='data'>
                <span>{dealerId}</span>
                <span>{industryIndicator ? `(${industryIndicator})` : industryIndicator.trim()}</span>
            </div>
            <span className='data'>{`${String(location.city)}, ${location.state}`}</span>

        </div>
    </div>;

DealerInfo.displayName = 'DealerInfo';
DealerInfo.propTypes = {
    dealerId: PropTypes.string.isRequired,
    dealerName: PropTypes.string.isRequired,
    industryIndicator: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired
};

export default DealerInfo;



// WEBPACK FOOTER //
// ./src/product/shared/components/dealer-info.js